import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';

import { toPounds } from '../../helpers/Currency';
import { translate as t } from '../../lib/I18n';
import DigitSpinner from './DigitSpinner';

function Price ({ showFree, price, className, animated, nonNegative, split, srOnly, id }) {
    if (showFree && !price) {
        return (
            <span className={ className }>
                { t('booking.delivery.free') }
            </span>
        );
    }

    const validatedPrice = nonNegative && price < 0 ? 0 : price;
    const amount = toPounds(validatedPrice).toFixed(2);
    const [pounds, pence] = amount.split('.', 2);
    const srText = `£${amount}`;
    return (
        <span className={cx('sr-container', className)} id={id}>
            <span aria-hidden="true">
                <span className="price__symbol">&pound;</span>
                {animated ? (
                    <DigitSpinner number={amount} />
                ) : split ? (
                    <React.Fragment>
                        <span className="price__pounds">{pounds}</span>
                        <span className="price__decimal">.</span>
                        <span className="price__pence">{pence}</span>
                    </React.Fragment>
                ) : (
                    amount
                )}
            </span>
            <span className="sr-text">{t(srOnly || srText, {price: srText})}</span>
        </span>
    );
}


Price.propTypes = {
    price: PropTypes.number,
    className: PropTypes.string,
    showFree: PropTypes.bool,
    animated: PropTypes.bool,
    nonNegative: PropTypes.bool,
    split: PropTypes.bool,
    srOnly: PropTypes.string,
    id: PropTypes.string
};

Price.defaultProps = {
    price: 0,
    showFree: false,
    className: '',
    animated: false,
    nonNegative: false,
    split: false,
};


export default Price;

